<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col md="9">
          <div><strong>Address</strong></div>
          <div>{{ address.address || '-'  }}</div>
        </b-col>
        <b-col md="3">
          <div><strong>Unit</strong></div>
          <div>{{ address.unit || '-' }}</div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="6">
          <div><strong>City</strong></div>
          <div>{{ address.city || '-'  }}</div>
        </b-col>
        <b-col md="3">
          <div><strong>State</strong></div>
          <div>{{ address.state || '-'  }}</div>
        </b-col>
        <b-col md="3">
          <div><strong>Zip Code</strong></div>
          <div>{{ address.zipCode || '-'  }}</div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/address/AddressDisplay.vue